import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LearningService } from 'src/app/services/learning/learning.service';

@Component({
  selector: 'app-class-book-title-map',
  templateUrl: './class-book-title-map.component.html',
  styleUrls: ['./class-book-title-map.component.css']
})
export class ClassBookTitleMapComponent implements OnInit {
  Submitted:boolean = false;
  BookTitleList=[];
  ClassBookTitleMapList=[];
  SubjectList=[];
  ClassList=[];
  SearchChapterTopicList=[];
  ChapterContentList=[];

  constructor(private learningservice:LearningService,private LookupService: LookupService, private globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

    SearchModel = {    
     BookTitleID: 0,
     ClassID:0,
     SubjectID:0,
  };
 ClearSearch(){
   this.SearchModel.ClassID=0;
   this.SearchModel.SubjectID=0;
   this.SearchModel.BookTitleID=0;
 }
  LearningModel = { 
    ClassBookTitleMapID:0,  
    ClassID:0,
    SubjectID:0,    
    BookTitleID: 0,
    IsActive: true,
};

  Clear() {
    this.LearningModel.ClassBookTitleMapID = 0;
    this.LearningModel.BookTitleID = 0;
    this.LearningModel.ClassID = 0;
    this.LearningModel.SubjectID = 0;
    this.Submitted = false;
}

Edit(obj) {
  this.LearningModel.ClassBookTitleMapID = obj.ClassBookTitleMapID;
  this.LearningModel.BookTitleID = obj.BookTitleID;
  this.LearningModel.ClassID = obj.ClassID;
  this.LearningModel.SubjectID = obj.SubjectID;
  this.LearningModel.IsActive = obj.IsActive;

}

ValidityState(){
  return this.LearningModel.ClassID==0||this.LearningModel.SubjectID==0||this.LearningModel.BookTitleID==0;
}


SaveClassBookTitleMapping() {  
  this.Submitted = true;
  if (!this.ValidityState()) {
    this.spinnerService.show();
    this.learningservice.SaveClassBookTitleMapping(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetAllClassBookTitleMapping();
      }
      if (data.webResponse.Status && this.LearningModel.ClassBookTitleMapID == 0) {
        this.Clear();
      }
      this.globalHelper.CheckActionStatus(data);
      this.spinnerService.hide();
    });
  }

};

GetAllClassBookTitleMapping() {
  this.spinnerService.show();
  this.learningservice.GetAllClassBookTitleMapping(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
    this.ClassBookTitleMapList = data.ClassBookTitleMapList;
    this.spinnerService.hide();
    this.globalHelper.CheckActionStatus(data);
  });
};

MarkActiveClassBookTitle(item) {
  this.LearningModel.ClassBookTitleMapID = item.ClassBookTitleMapID;
  this.LearningModel.IsActive = item.IsActive == true ? false : true;
  this.spinnerService.show();
  this.learningservice.MarkActiveClassBookTitle(JSON.stringify(this.LearningModel)).subscribe((data: any) => {
    if (data.webResponse.Status) {
      this.GetAllClassBookTitleMapping();
    }
   
    this.globalHelper.CheckActionStatus(data);
    this.spinnerService.hide();
  });
};



  ngOnInit() {
    this.GetClass();    
    this.GetBookTitle(); 
   
  }

  GetBookTitle() {
    this.LookupService.GetLookupsList('LearningBookTitle', '').subscribe((data: any) => {
      this.BookTitleList = data.LookupItems;
    });
  }
  
  BookTitleSearchList=[];
  BindClassSubjectBookTitle() {
    this.SearchModel.BookTitleID=0;
    var ItemBO={
     'ItemID':this.SearchModel.ClassID,
     'ItemID1':this.SearchModel.SubjectID
   }
    this.LookupService.GetLookupsList('SubjectBookTitle', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.BookTitleSearchList = data.LookupItems;
    });

  }
 
  GetClass() {
    this.LookupService.GetLookupsList('Class', '').subscribe((data) => {
      this.ClassList = data.LookupItems;
    });

  };
  GetClassSubject() {
    this.LookupService.GetLookupsList('ClassSubject', '').subscribe((data) => {
      this.SubjectList = data.LookupItems;
    });
  };

  SubjectSearchList=[];
  BindClassSubject() {
    this.SearchModel.SubjectID=0;
    var ItemBO={
     'ItemID':this.SearchModel.ClassID
   }
    this.LookupService.GetLookupsList('ClassSubject', JSON.stringify(ItemBO)).subscribe((data: any) => {
      this.SubjectSearchList = data.LookupItems;
    });

  }

}






